import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

@Component({
	selector: 'bt-photographer-order-detail',
	standalone: false,
	templateUrl: './photographer-order-detail.html',
	styleUrl: './photographer-order-detail.scss'
})
export class PhotographerOrderDetailComponent implements OnInit {
	orderId: string | number | null = null;
	activeSubRoute: string;
	isCreateMode = false;

	readonly #destroyRef = inject(DestroyRef);
	readonly #router = inject(Router);

	tabs = [
		{ id: 'orderInfo', title: 'Order Info', url: 'order-detail-info', disabled: false },
		{ id: 'orderDetails', title: 'Order Details', url: 'order-detail-shots', disabled: false }
	];

	constructor() {
		this.#router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				takeUntilDestroyed(this.#destroyRef)
			)
			.subscribe(() => {
				this.updateRouteInfo();
			});
	}

	ngOnInit(): void {
		this.updateRouteInfo();
	}

	private updateRouteInfo(): void {
		const url = this.#router.url;
		const urlSegments = url.split('/');

		const orderViewIndex = urlSegments.indexOf('order-view');
		if (orderViewIndex !== -1 && urlSegments.length > orderViewIndex + 1) {
			const idSegment = urlSegments[orderViewIndex + 1];
			this.orderId = idSegment === 'new' ? 'new' : !isNaN(Number(idSegment)) ? Number(idSegment) : null;
			this.isCreateMode = this.orderId === 'new';

			if (this.isCreateMode) {
				this.tabs[1].disabled = true; // Disable "Order Details" tab in create mode
			} else {
				this.tabs[1].disabled = false; // Enable "Order Details" tab in view mode
			}

			if (urlSegments.length > orderViewIndex + 2) {
				this.activeSubRoute = urlSegments[orderViewIndex + 2];
			}
		}
	}

	onBack(): void {
		this.#router.navigate(['/photographer/order-list']);
	}

	selectTab(tabUrl: string): void {
		const id = this.orderId === 'new' ? 'new' : this.orderId;
		this.#router.navigate(['/photographer/order-view', id, tabUrl]);
	}
}
